import React from 'react';

import type { IViewModelProps } from 'controller/types';

export const ControllerContext = React.createContext<IViewModelProps>(
  {} as IViewModelProps,
);
